import React from "react";
import { Button } from "antd";
import { MdModeEdit } from "react-icons/md";
import { useHistory } from "react-router-dom";
import Can from "../../../../../casl/Can";
import { PERMISSIONS } from "constants/permissions";
export default function Edit({ text }) {
  const history = useHistory();
  const handleEdit = (id) => {
    localStorage.setItem("new", false);
    history.push({
      pathname: `/catalogue-table/${id}/edit`,
      state: {
        type: "edit",
      },
    });
  };

  return (
    //  {/* //casl starts here  */}
    <Can
      I={PERMISSIONS.update_catalogues.slug}
      a={PERMISSIONS.update_catalogues.permissionType}
    >
      {(allowed) => (
        <Button
          size="large"
          type="default"
          className="table-control"
          icon={<MdModeEdit size={25} />}
          onClick={() => handleEdit(text?.id)}
        ></Button>
      )}
    </Can>
    // {/* //casl ends here  */}
  );
}
